export function getAuthLogoutUrl() {
  const idtoken = localStorage.getItem('idToken');
  const clientid = localStorage.getItem('clientId');

  return `${import.meta.env.VITE_KEYCLOAK_URL}/realms/happify/protocol/openid-connect/logout?&post_logout_redirect_uri=${import.meta.env.VITE_HAPPIFY_URL}&id_token_hint=${idtoken}&client_id=${clientid}`;
}
